var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { alertErrorHandler, showSuccess } from '@spike/notifications-action';
import axios from 'axios';
import { MEMBERSHIPS_ADD_ENROLLMENT_ERROR_ACTION_TYPE, MEMBERSHIPS_ADD_ENROLLMENT_START_ACTION_TYPE, MEMBERSHIPS_ADD_ENROLLMENT_SUCCESS_ACTION_TYPE, MEMBERSHIPS_ADD_START_ACTION_TYPE, MEMBERSHIPS_ADD_SUCCESS_ACTION_TYPE, MEMBERSHIPS_CANCEL_ENROLLMENT_ERROR_ACTION_TYPE, MEMBERSHIPS_CANCEL_ENROLLMENT_START_ACTION_TYPE, MEMBERSHIPS_CANCEL_ENROLLMENT_SUCCESS_ACTION_TYPE, MEMBERSHIPS_CHANGE_STATUS_ERROR_ACTION_TYPE, MEMBERSHIPS_CHANGE_STATUS_START_ACTION_TYPE, MEMBERSHIPS_CHANGE_STATUS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_CHECK_ORDER_ERROR_ACTION_TYPE, MEMBERSHIPS_CHECK_ORDER_START_ACTION_TYPE, MEMBERSHIPS_CHECK_ORDER_SUCCESS_ACTION_TYPE, MEMBERSHIPS_DELETE_ENROLLMENT_ERROR_ACTION_TYPE, MEMBERSHIPS_DELETE_ENROLLMENT_START_ACTION_TYPE, MEMBERSHIPS_DELETE_ENROLLMENT_SUCCESS_ACTION_TYPE, MEMBERSHIPS_ERROR_ACTION_TYPE, MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_ERROR_ACTION_TYPE, MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_START_ACTION_TYPE, MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENT_ERROR_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENT_START_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENT_SUCCESS_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENTS_ERROR_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENTS_START_ACTION_TYPE, MEMBERSHIPS_GET_ENROLLMENTS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_GET_START_ACTION_TYPE, MEMBERSHIPS_GET_SUCCESS_ACTION_TYPE, MEMBERSHIPS_UPDATE_PAYMENT_METHOD_ERROR_ACTION_TYPE, MEMBERSHIPS_UPDATE_PAYMENT_METHOD_START_ACTION_TYPE, MEMBERSHIPS_UPDATE_PAYMENT_METHOD_SUCCESS_ACTION_TYPE, MEMBERSHIPS_RETRY_PAYMENT_START_ACTION_TYPE, MEMBERSHIPS_RETRY_PAYMENT_SUCCESS_ACTION_TYPE, MEMBERSHIPS_RETRY_PAYMENT_ERROR_ACTION_TYPE, MEMBERSHIPS_SEARCH_ENROLLMENTS_START_ACTION_TYPE, MEMBERSHIPS_SEARCH_ENROLLMENTS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_SEARCH_ENROLLMENTS_ERROR_ACTION_TYPE, MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_START_ACTION_TYPE, MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_ERROR_ACTION_TYPE, MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_START_ACTION_TYPE, MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_ERROR_ACTION_TYPE, MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_START_ACTION_TYPE, MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_SUCCESS_ACTION_TYPE, MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_ERROR_ACTION_TYPE } from './MembershipsActionsTypes';
import { convertToCheckoutEnrollments, convertToEnrollment, convertToEnrollmentPending, convertToMembership, convertToSaveDto } from './MembershipsConverter';
var membershipsUrl = '/memberships';
var enrollmentsUrl = '/enrollments';
var enrollmentSearchUrl = '/enrollment/search';
var checkOrderUrl = '/check_order_membership';
var lookupUrl = '/membership/look_up';
export var fetchMembershipsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var marketplaceId, url, response, memberships, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    marketplaceId = apiClientWrapper.marketplaceId;
                    url = "".concat(membershipsUrl, "?marketplace_id=").concat(marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    memberships = response.data.map(convertToMembership);
                    dispatch(getSuccess(memberships));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    console.error({ apiError: apiError_1 });
                    if (!axios.isCancel(apiError_1)) {
                        dispatch(error());
                        alertErrorHandler(apiError_1, dispatch, 'Error fetching memberships.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var addMembershipThunk = function (apiClientWrapper, membershipData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, membershipSaveDto, response, membership, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(addStart());
                    url = "".concat(membershipsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    membershipSaveDto = convertToSaveDto(membershipData);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, { membership: membershipSaveDto }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    membership = convertToMembership(response.data);
                    dispatch(addSuccess(membership));
                    dispatch(showSuccess('Membership added successfully.'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    console.error({ apiError: apiError_2 });
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        alertErrorHandler(apiError_2, dispatch, 'Error adding membership.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeMembershipStatusThunk = function (apiClientWrapper, membershipId, isActive) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, membership, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeStatusStart());
                    url = "".concat(membershipsUrl, "/").concat(membershipId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, { membership: { marketplace_id: apiClientWrapper.marketplaceId, active: isActive } }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    membership = convertToMembership(response.data);
                    dispatch(changeStatusSuccess(membership));
                    dispatch(showSuccess("Membership ".concat(isActive ? 'activated' : 'deactivated', " successfully.")));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    console.error({ apiError: apiError_3 });
                    if (!axios.isCancel(apiError_3)) {
                        dispatch(changeStatusError());
                        alertErrorHandler(apiError_3, dispatch, "Error ".concat(isActive ? 'activating' : 'deactivating', " membership."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var addEnrollmentThunk = function (apiClientWrapper, membershipId, customerId, petIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, enrollmentData, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(addEnrollmentStart());
                    url = "".concat(enrollmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    enrollmentData = {
                        marketplace_id: apiClientWrapper.marketplaceId,
                        membership_id: membershipId,
                        customer_id: customerId,
                        pet_ids: petIds
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, { enrollment: enrollmentData }, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(addEnrollmentSuccess(convertToEnrollmentPending(response.data)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    console.error({ apiError: apiError_4 });
                    if (!axios.isCancel(apiError_4)) {
                        dispatch(addEnrollmentError());
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteEnrollmentThunk = function (apiClientWrapper, enrollmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteEnrollmentStart());
                    url = "".concat(enrollmentsUrl, "/").concat(enrollmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteEnrollmentSuccess(enrollmentId));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    console.error({ apiError: apiError_5 });
                    if (!axios.isCancel(apiError_5)) {
                        dispatch(deleteEnrollmentError());
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var checkOrderThunk = function (apiClientWrapper, orderId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, result, apiError_6;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(checkOrderStart(requestUuid));
                    url = "".concat(checkOrderUrl, "/").concat(orderId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    result = _a.sent();
                    getState().memberships.requestUuids.checkOrder === requestUuid && dispatch(checkOrderSuccess(orderId, result.data.result));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _a.sent();
                    console.error({ apiError: apiError_6 });
                    if (!axios.isCancel(apiError_6)) {
                        alertErrorHandler(apiError_6, dispatch, 'Error checking memberships for order.');
                        dispatch(checkOrderError());
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchMembershipEnrollmentsThunk = function (apiClientWrapper, membershipId, page, status, size) {
    if (page === void 0) { page = 1; }
    if (size === void 0) { size = 10; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, enrollments, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(getEnrollmentsStart(requestUuid));
                    url = "".concat(membershipsUrl, "/").concat(membershipId, "/enrollments?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&page=").concat(page).concat(status ? "&status=".concat(status) : '', "&per_page=").concat(size);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    if (getState().memberships.lastFetchMembershipRequestUuid === requestUuid) {
                        enrollments = response.data.enrollments.map(function (enrollmentDto) {
                            return convertToEnrollment(enrollmentDto, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone);
                        });
                        dispatch(getEnrollmentsSuccess(membershipId, enrollments, response.data.current_page, response.data.total_pages, response.data.total_enrollments, response.data.per_page));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    console.error({ apiError: apiError_7 });
                    if (!axios.isCancel(apiError_7)) {
                        dispatch(getEnrollmentsError());
                        alertErrorHandler(apiError_7, dispatch, 'Error fetching membership enrollments.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cancelEnrollmentThunk = function (apiClientWrapper, enrollmentId, canceledAt, cancellationReason) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, enrollmentData, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(cancelEnrollmentStart());
                    url = "".concat(enrollmentsUrl, "/").concat(enrollmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    enrollmentData = {
                        canceled_at: canceledAt,
                        cancellation_reason: cancellationReason
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, { enrollment: enrollmentData }, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(cancelEnrollmentSuccess(enrollmentId));
                    dispatch(showSuccess('Enrollment canceled successfully.'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    console.error({ apiError: apiError_8 });
                    if (!axios.isCancel(apiError_8)) {
                        dispatch(cancelEnrollmentError());
                        alertErrorHandler(apiError_8, dispatch, 'Error canceling enrollment.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getEnrollmentThunk = function (apiClientWrapper, enrollmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, enrollment, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getEnrollmentStart());
                    url = "".concat(enrollmentsUrl, "/").concat(enrollmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    enrollment = convertToEnrollment(response.data, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone);
                    dispatch(getEnrollmentSuccess(enrollment));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    console.error({ apiError: apiError_9 });
                    if (!axios.isCancel(apiError_9)) {
                        dispatch(getEnrollmentError());
                        alertErrorHandler(apiError_9, dispatch, 'Error fetching enrollment.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchCheckoutEnrollmentsThunk = function (apiClientWrapper, orderId) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, result, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchCheckoutEnrollmentsStart(requestUuid));
                    url = "".concat(lookupUrl, "/").concat(orderId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    result = _a.sent();
                    getState().memberships.requestUuids.fetchCheckoutEnrollments === requestUuid && dispatch(fetchCheckoutEnrollmentsSuccess(convertToCheckoutEnrollments(result.data, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    console.error({ apiError: apiError_10 });
                    if (!axios.isCancel(apiError_10)) {
                        alertErrorHandler(apiError_10, dispatch, 'Error fetching checkout memberships.');
                        dispatch(fetchCheckoutEnrollmentsError());
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateEnrollmentPaymentMethodThunk = function (apiClientWrapper, enrollmentId, paymentMethodId, showNotification) {
    if (showNotification === void 0) { showNotification = true; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, enrollmentData, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(updatePaymentMethodStart());
                    url = "".concat(enrollmentsUrl, "/").concat(enrollmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    enrollmentData = {
                        payment_method_id: paymentMethodId
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, { enrollment: enrollmentData }, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(updatePaymentMethodSuccess(enrollmentId));
                    if (showNotification) {
                        dispatch(showSuccess('Payment method updated successfully.'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    console.error({ apiError: apiError_11 });
                    if (!axios.isCancel(apiError_11)) {
                        dispatch(updatePaymentMethodError());
                        alertErrorHandler(apiError_11, dispatch, 'Error updating payment method.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var retryPaymentThunk = function (apiClientWrapper, enrollmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(retryPaymentStart());
                    url = "".concat(enrollmentsUrl, "/").concat(enrollmentId, "/collect?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, null, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(retryPaymentSuccess(enrollmentId));
                    dispatch(showSuccess('Payment processed successfully.'));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    console.error({ apiError: apiError_12 });
                    if (!axios.isCancel(apiError_12)) {
                        dispatch(retryPaymentError());
                        alertErrorHandler(apiError_12, dispatch, 'Error processing payment.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var retryMultiplePaymentsThunk = function (apiClientWrapper, enrollmentIds, showNotification) {
    if (showNotification === void 0) { showNotification = true; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, enrollmentData, apiError_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(retryMultiplePaymentsStart());
                    url = "".concat(enrollmentsUrl, "_collect?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    enrollmentData = {
                        enrollment_ids: enrollmentIds
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, enrollmentData, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(retryMultiplePaymentsSuccess(enrollmentIds));
                    if (showNotification) {
                        dispatch(showSuccess('Payment processed successfully.'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _a.sent();
                    console.error({ apiError: apiError_13 });
                    if (!axios.isCancel(apiError_13)) {
                        dispatch(retryMultiplePaymentsError());
                        alertErrorHandler(apiError_13, dispatch, 'Error processing payment.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var searchEnrollmentsThunk = function (apiClientWrapper, searchText, membershipId, page, size, status) {
    if (page === void 0) { page = 1; }
    if (size === void 0) { size = 10; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, enrollments, apiError_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(searchEnrollmentsStart());
                    url = "".concat(enrollmentSearchUrl, "/").concat(searchText, "?marketplace_id=").concat(apiClientWrapper.marketplaceId).concat(membershipId ? "&membership_id=".concat(membershipId) : '', "&page=").concat(page, "&per_page=").concat(size).concat(status ? "&status=".concat(status) : '');
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    enrollments = response.data.enrollments.map(function (enrollmentDto) {
                        return convertToEnrollment(enrollmentDto, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone);
                    });
                    dispatch(searchEnrollmentsSuccess(enrollments, response.data.current_page, response.data.total_pages, response.data.total_enrollments, response.data.per_page));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _a.sent();
                    console.error({ apiError: apiError_14 });
                    if (!axios.isCancel(apiError_14)) {
                        dispatch(searchEnrollmentsError());
                        alertErrorHandler(apiError_14, dispatch, 'Error searching enrollments.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchMarketplaceEnrollmentsThunk = function (apiClientWrapper, page, status, size) {
    if (page === void 0) { page = 1; }
    if (size === void 0) { size = 10; }
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, enrollments, apiError_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(getMarketplaceEnrollmentsStart(requestUuid));
                    url = "".concat(enrollmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&page=").concat(page).concat(status ? "&status=".concat(status) : '', "&per_page=").concat(size);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    if (getState().memberships.lastFetchMarketplaceRequestUuid === requestUuid) {
                        enrollments = response.data.enrollments.map(function (enrollmentDto) {
                            return convertToEnrollment(enrollmentDto, apiClientWrapper.masterData, apiClientWrapper.marketplace, apiClientWrapper.timeZone);
                        });
                        dispatch(fetchMarketplaceEnrollmentsSuccess(enrollments, response.data.current_page, response.data.total_pages, response.data.total_enrollments, response.data.per_page));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_15 = _a.sent();
                    console.error({ apiError: apiError_15 });
                    if (!axios.isCancel(apiError_15)) {
                        dispatch(fetchMarketplaceEnrollmentsError());
                        alertErrorHandler(apiError_15, dispatch, 'Error fetching marketplace enrollments.');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateMultipleEnrollmentsPaymentMethodThunk = function (apiClientWrapper, enrollmentIds, paymentMethodId, showNotification) {
    if (showNotification === void 0) { showNotification = true; }
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, enrollmentData, apiError_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(updateMultiplePaymentMethodsStart());
                    url = "".concat(enrollmentsUrl, "_update_payment_method?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    enrollmentData = {
                        payment_method_id: paymentMethodId,
                        enrollment_ids: enrollmentIds
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, enrollmentData, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(updateMultiplePaymentMethodsSuccess(enrollmentIds));
                    if (showNotification) {
                        dispatch(showSuccess('Payment method updated successfully'));
                    }
                    return [3 /*break*/, 4];
                case 3:
                    apiError_16 = _a.sent();
                    console.error({ apiError: apiError_16 });
                    if (!axios.isCancel(apiError_16)) {
                        dispatch(updateMultiplePaymentMethodsError());
                        alertErrorHandler(apiError_16, dispatch, 'Error updating payment method');
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
var getStart = function () {
    return {
        type: MEMBERSHIPS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (memberships) {
    return {
        type: MEMBERSHIPS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            memberships: memberships,
        },
    };
};
var addStart = function () {
    return {
        type: MEMBERSHIPS_ADD_START_ACTION_TYPE,
    };
};
var addSuccess = function (membership) {
    return {
        type: MEMBERSHIPS_ADD_SUCCESS_ACTION_TYPE,
        payload: {
            membership: membership,
        },
    };
};
var error = function () {
    return {
        type: MEMBERSHIPS_ERROR_ACTION_TYPE,
    };
};
var changeStatusStart = function () {
    return {
        type: MEMBERSHIPS_CHANGE_STATUS_START_ACTION_TYPE,
    };
};
var changeStatusSuccess = function (membership) {
    return {
        type: MEMBERSHIPS_CHANGE_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            membership: membership,
        },
    };
};
var changeStatusError = function () {
    return {
        type: MEMBERSHIPS_CHANGE_STATUS_ERROR_ACTION_TYPE,
    };
};
var addEnrollmentStart = function () {
    return {
        type: MEMBERSHIPS_ADD_ENROLLMENT_START_ACTION_TYPE,
    };
};
var addEnrollmentSuccess = function (enrollment) {
    return {
        type: MEMBERSHIPS_ADD_ENROLLMENT_SUCCESS_ACTION_TYPE,
        payload: {
            enrollment: enrollment,
        },
    };
};
var addEnrollmentError = function () {
    return {
        type: MEMBERSHIPS_ADD_ENROLLMENT_ERROR_ACTION_TYPE,
    };
};
var deleteEnrollmentStart = function () {
    return {
        type: MEMBERSHIPS_DELETE_ENROLLMENT_START_ACTION_TYPE,
    };
};
var deleteEnrollmentSuccess = function (enrollmentId) {
    return {
        type: MEMBERSHIPS_DELETE_ENROLLMENT_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentId: enrollmentId,
        },
    };
};
var deleteEnrollmentError = function () {
    return {
        type: MEMBERSHIPS_DELETE_ENROLLMENT_ERROR_ACTION_TYPE,
    };
};
var checkOrderStart = function (requestUuid) {
    return {
        type: MEMBERSHIPS_CHECK_ORDER_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
var checkOrderSuccess = function (orderId, hasMemberships) {
    return {
        type: MEMBERSHIPS_CHECK_ORDER_SUCCESS_ACTION_TYPE,
        payload: {
            orderId: orderId,
            hasMemberships: hasMemberships
        },
    };
};
var checkOrderError = function () {
    return {
        type: MEMBERSHIPS_CHECK_ORDER_ERROR_ACTION_TYPE,
    };
};
var getEnrollmentsStart = function (requestUuid) {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENTS_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
var getEnrollmentsSuccess = function (membershipId, enrollments, currentPage, totalPages, totalEnrollments, size) {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            membershipId: membershipId,
            enrollments: enrollments,
            currentPage: currentPage,
            totalPages: totalPages,
            totalEnrollments: totalEnrollments,
            size: size
        }
    };
};
var getEnrollmentsError = function () {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENTS_ERROR_ACTION_TYPE
    };
};
var cancelEnrollmentStart = function () {
    return {
        type: MEMBERSHIPS_CANCEL_ENROLLMENT_START_ACTION_TYPE
    };
};
var cancelEnrollmentSuccess = function (enrollmentId) {
    return {
        type: MEMBERSHIPS_CANCEL_ENROLLMENT_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentId: enrollmentId
        }
    };
};
var cancelEnrollmentError = function () {
    return {
        type: MEMBERSHIPS_CANCEL_ENROLLMENT_ERROR_ACTION_TYPE
    };
};
var getEnrollmentStart = function () {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENT_START_ACTION_TYPE
    };
};
var getEnrollmentSuccess = function (enrollment) {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENT_SUCCESS_ACTION_TYPE,
        payload: {
            enrollment: enrollment
        }
    };
};
var getEnrollmentError = function () {
    return {
        type: MEMBERSHIPS_GET_ENROLLMENT_ERROR_ACTION_TYPE
    };
};
var fetchCheckoutEnrollmentsStart = function (requestUuid) {
    return {
        type: MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
var fetchCheckoutEnrollmentsSuccess = function (checkoutEnrollments) {
    return {
        type: MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            checkoutEnrollments: checkoutEnrollments
        },
    };
};
var fetchCheckoutEnrollmentsError = function () {
    return {
        type: MEMBERSHIPS_FETCH_CHECKOUT_ENROLLMENTS_ERROR_ACTION_TYPE,
    };
};
var updatePaymentMethodStart = function () {
    return {
        type: MEMBERSHIPS_UPDATE_PAYMENT_METHOD_START_ACTION_TYPE
    };
};
var updatePaymentMethodSuccess = function (enrollmentId) {
    return {
        type: MEMBERSHIPS_UPDATE_PAYMENT_METHOD_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentId: enrollmentId
        }
    };
};
var updatePaymentMethodError = function () {
    return {
        type: MEMBERSHIPS_UPDATE_PAYMENT_METHOD_ERROR_ACTION_TYPE
    };
};
var retryPaymentStart = function () {
    return {
        type: MEMBERSHIPS_RETRY_PAYMENT_START_ACTION_TYPE
    };
};
var retryPaymentSuccess = function (enrollmentId) {
    return {
        type: MEMBERSHIPS_RETRY_PAYMENT_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentId: enrollmentId
        }
    };
};
var retryPaymentError = function () {
    return {
        type: MEMBERSHIPS_RETRY_PAYMENT_ERROR_ACTION_TYPE
    };
};
var retryMultiplePaymentsStart = function () {
    return {
        type: MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_START_ACTION_TYPE
    };
};
var retryMultiplePaymentsSuccess = function (enrollmentIds) {
    return {
        type: MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentIds: enrollmentIds
        }
    };
};
var retryMultiplePaymentsError = function () {
    return {
        type: MEMBERSHIPS_RETRY_MULTIPLE_PAYMENTS_ERROR_ACTION_TYPE
    };
};
var searchEnrollmentsStart = function () {
    return {
        type: MEMBERSHIPS_SEARCH_ENROLLMENTS_START_ACTION_TYPE
    };
};
var searchEnrollmentsSuccess = function (enrollments, currentPage, totalPages, totalEnrollments, size) {
    return {
        type: MEMBERSHIPS_SEARCH_ENROLLMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            enrollments: enrollments,
            currentPage: currentPage,
            totalPages: totalPages,
            totalEnrollments: totalEnrollments,
            size: size
        }
    };
};
var searchEnrollmentsError = function () {
    return {
        type: MEMBERSHIPS_SEARCH_ENROLLMENTS_ERROR_ACTION_TYPE
    };
};
var getMarketplaceEnrollmentsStart = function (requestUuid) {
    return {
        type: MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid
        }
    };
};
var fetchMarketplaceEnrollmentsSuccess = function (enrollments, currentPage, totalPages, totalEnrollments, size) {
    return {
        type: MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            enrollments: enrollments,
            currentPage: currentPage,
            totalPages: totalPages,
            totalEnrollments: totalEnrollments,
            size: size
        }
    };
};
var fetchMarketplaceEnrollmentsError = function () {
    return {
        type: MEMBERSHIPS_GET_MARKETPLACE_ENROLLMENTS_ERROR_ACTION_TYPE
    };
};
var updateMultiplePaymentMethodsStart = function () {
    return {
        type: MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_START_ACTION_TYPE
    };
};
var updateMultiplePaymentMethodsSuccess = function (enrollmentIds) {
    return {
        type: MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_SUCCESS_ACTION_TYPE,
        payload: {
            enrollmentIds: enrollmentIds
        }
    };
};
var updateMultiplePaymentMethodsError = function () {
    return {
        type: MEMBERSHIPS_UPDATE_MULTIPLE_PAYMENT_METHODS_ERROR_ACTION_TYPE
    };
};
